import { createContext, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { ConsultantuseLocalStorage } from "./ConsultantuseLocalStorage";
const ConsultantAuthContext = createContext();

export const ConsultantAuthProvider = ({ children }) => {
  const [user, setUser] = ConsultantuseLocalStorage("Consultantuser", null);
  const navigate = useNavigate();

  // call this function when you want to authenticate the user
  const loginConsultant = async (data, token) => {
    setUser(data);

    localStorage.setItem("Consultant_id", data[0]._id);
    localStorage.setItem("Consultant_Password", data[0].MetaData.Password);
    localStorage.setItem("ConsultantToken", token);
    navigate("/Consultant");
  };

  // call this function to sign out logged in user
  const logoutConsultant = () => {
    setUser(null);
    localStorage.clear();
    navigate("/Consultant/login", { replace: true });
  };

  const value = useMemo(
    () => ({
      user,
      loginConsultant,
      logoutConsultant,
    }),
    [user]
  );
  return (
    <ConsultantAuthContext.Provider value={value}>
      {children}
    </ConsultantAuthContext.Provider>
  );
};

export const ConsultantuseAuth = () => {
  return useContext(ConsultantAuthContext);
};
